"use client";

import { motion } from "framer-motion";
import clsx from "clsx";
import { NewsPageQueryResult } from "@/sanity.types";
import { useMediaQuery } from "@/app/(site)/_hooks/useMediaQuery";
import { hardcodedContent } from "@/app/(site)/_lib/global-content";

type UserActionsProps = {
	newsCategories: NonNullable<NewsPageQueryResult>["newsCategories"];
	totalNewsCount: number;
	activeCategoryId: string | null;
	onCategoryChange: (categoryId: string | null) => void;
};

export default function UserActions({ newsCategories, totalNewsCount, activeCategoryId, onCategoryChange }: UserActionsProps) {
	const isDesktop = useMediaQuery("(min-width: 990px)");

	const handleCategoryClick = (categoryId: string | null) => {
		onCategoryChange(categoryId);

		if (isDesktop) {
			setTimeout(() => {
				const gridElement = document.getElementById("newsGrid");
				if (gridElement) {
					const rect = gridElement.getBoundingClientRect();
					const scrollTop = window.pageYOffset + rect.top - 200;
					window.scrollTo({
						top: scrollTop,
						behavior: "smooth",
					});
				}
			}, 0);
		}
	};

	return (
		<>
			<motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.2, duration: 0.3 }} className="text-cap-m">
				<div className="flex flex-wrap items-center gap-2">
					<button
						aria-label="Filter All"
						onClick={() => handleCategoryClick(null)}
						className={clsx(
							"cursor-pointer rounded-[0.269rem] px-[1.063rem] py-2.5 uppercase transition-colors duration-200",
							activeCategoryId === null
								? "text-navy-blue-deep bg-navy-blue-light"
								: "text-graphite-black-middle border-graphite-black-middle hover:border-navy-blue-deep hover:text-navy-blue-deep border",
						)}
					>
						<span className={clsx("text-cap-m")}>
							{hardcodedContent.all} ({totalNewsCount})
						</span>
					</button>
					{newsCategories.map((category) => {
						return (
							<button
								aria-label={category.categoryName}
								key={category._id}
								onClick={() => handleCategoryClick(category._id)}
								className={clsx(
									"cursor-pointer rounded-[0.269rem] px-[1.063rem] py-2.5 uppercase transition-colors duration-200",
									activeCategoryId === category._id
										? "text-navy-blue-deep bg-navy-blue-light"
										: "text-graphite-black-middle border-graphite-black-middle hover:border-navy-blue-deep hover:text-navy-blue-deep border",
								)}
							>
								<span className={clsx("text-cap-m")}>{category.categoryName}</span>
							</button>
						);
					})}
				</div>
			</motion.div>
		</>
	);
}
